// actionTypes.js
export const CHECK_TXID = "CHECK_TXID"
export const CHECK_TXID_SUCCESS = "CHECK_TXID_SUCCESS"
export const CHECK_TXID_FAIL = "CHECK_TXID_FAIL"
